import { enableProdMode } from '@angular/core'
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic'

import { AppModule } from './app/app.module'
import { environment } from './environments/environment'
import * as Sentry from '@sentry/angular-ivy'

if (environment.production) {
  enableProdMode()
  if (window) {
    window.console.log = function () {
      // Console log is disabled in production mode
    }
  }
}

Sentry.init({
  dsn: environment.sentry_dsn,
  environment: environment.production ? 'production' : 'development',
  integrations: [
    new Sentry.BrowserTracing({
      tracePropagationTargets: ['localhost', environment.apiUrl],
      routingInstrumentation: Sentry.routingInstrumentation,
    }),
  ],
  tracesSampleRate: environment.sentryTracesSampleRate ? environment.sentryTracesSampleRate : 1.0,
  sampleRate: environment.sentrySampleRate ? environment.sentrySampleRate : 1.0,
  enabled: environment.sentryEnabled,
})

document.addEventListener('DOMContentLoaded', () => {
  platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.error(err))
})
